exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-button--text[data-v-6bc113e4]{font-weight:600}.timelineitem[data-v-6bc113e4]{margin-bottom:-8px}.el-timeline-item[data-v-6bc113e4]{padding-bottom:8px !important}.ellipsis[data-v-6bc113e4]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.interchange-event-clickable[data-v-6bc113e4]{cursor:pointer}.interchange-event-clickable[data-v-6bc113e4]:hover{opacity:.88}", ""]);

// exports
